import React from 'react';
import styled from 'styled-components';

import WP from 'WP';
import css from 'css';
import SocialIcon from 'images/SocialIcon';

export default props => {
    const { onLastLinkBlur, zoom } = props;
    return (
        <LinkList className="social-links" color={props.color || css.colors.main} zoom={zoom}>
            <li>
                <a href={WP.options.facebook_link}><span><SocialIcon color={props.color || css.colors.main} icon="facebook"/></span>Facebook</a>
            </li>
            <li>
                <a href={WP.options.twitter_link}><span><SocialIcon color={props.color || css.colors.main} icon="twitter"/></span>Twitter</a>
            </li>
            <li>
                <a href={WP.options.youtube_link}><span><SocialIcon color={props.color || css.colors.main} icon="youtube"/></span>Youtube</a>
            </li>
            <li>
                <a href={WP.options.instagram_link}><span><SocialIcon color={props.color || css.colors.main} icon="instagram"/></span>Instagram</a>
            </li>
            <li>
                <a href={WP.options.linkedin_link} onBlur={() => onLastLinkBlur ? onLastLinkBlur() : null}><span><SocialIcon color={props.color || css.colors.main} icon="linkedin"/></span>Linkedin</a>
            </li>
        </LinkList>
    );
}

const LinkList = styled.ul`
    li {
        a {
            display:flex;
            align-items: center; 
            transition:all .2s ease-in-out;
            color: ${props => props.color};
            span {
                width:22px;
                margin-right:15px;
                text-align:center;
                display:flex;
                align-items: center;
                justify-content: center;
            }
            ${props => props.zoom ? `
                svg {
                    transition: all .2s ease-in-out;
                }
                &:hover, &:focus {
                    svg {
                        transform: scale(1.5);
                    }
                }
            ` : ``}
        }
    }
`



// WEBPACK FOOTER //
// ./src/partials/SocialLinks.js